import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=f6f22db0"
import script from "./AccountView.vue?vue&type=script&lang=ts"
export * from "./AccountView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f22db0')) {
      api.createRecord('f6f22db0', component.options)
    } else {
      api.reload('f6f22db0', component.options)
    }
    module.hot.accept("./AccountView.vue?vue&type=template&id=f6f22db0", function () {
      api.rerender('f6f22db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountView.vue"
export default component.exports